<div class="reopen-wrapper">
    <h1 mat-dialog-title>Reopen Property</h1>
    <div mat-dialog-content>
        Reopening the property needs to be re-submitted. Are you sure to perform this action?
    </div>
    <div mat-dialog-actions>
    <button mat-button mat-dialog-close>No</button>
    <button mat-button mat-dialog-close cdkFocusInitial (click)="reopenProperty()">Ok</button>
    </div>
</div>